import { createContext } from 'react';

export const fieldPathContext = createContext('');
